module.exports = __webpack_public_path__ + "static/img/12.92cc354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/xxw/12.jpg
// module id = ppuF
// module chunks = 1